import TrainPlanDetail from '@/pages/Train/TrainPlanDetail'
import ResViews from '@/pages/ResManager/ResViews'
import ResDetail from '@/pages/ResManager/ResDetail'
import KnowledgeBase from '@/pages/ResManager/KnowledgeBase'
import Course from '@/pages/Course/Course'
import MyCourse from '@/pages/Course/MyCourse'
import TheoryCourseAdd from '@/pages/Course/TheoryCourseAdd';
import ImageCourseAdd from '@/pages/Course/ImageCourseAdd'
import PaperPreview from '@/pages/Paper/Components/PaperPreview'

import i18n from '@/assets/i18n'

/**
 *  参数说明：
 *  1. props设为true，可以在组件中把参数当做prop使用
 *  2. meta: 2.1 single设为true，则为应用级的单页，见app.vue
 *           2.2 title，二级页面需要手动设置title，面包屑需要此名称
 */

export default [
    {
        path: '/teacher/home',
        name: 'teacherHome',
        component: () => import('@/pages/Home/Teacher')
    },
    {
        path: '/monitor',
        name: 'monitorScreen',
        component: () => import('@/pages/Monitor/MonitorScreen'),
        meta: {single: false},
    },

    // 培训管理
    {
        path: '/train/trainPlan',
        name: 'trainPlan',
        component: () => import('@/pages/Train/TrainPlan'),
        children: [{
            path: 'add',
            name: 'addTrainPlan',
            component: () => import('@pages/Train/TrainPlanEdit/index'),
            meta: {title: i18n.t('train.newOnlineTraining')}
        }, {
            path: 'addOffline',
            name: 'addOfflinePlan',
            component: () => import('@pages/Train/OfflinePlanEdit'),
            meta: {title: i18n.t('train.newOfflineTraining')}
        }, {
            path: 'detail/:planId',
            name: 'trainPlanDetail',
            component: TrainPlanDetail,
            props: true,
            meta: {title: i18n.t('train.trainDetail')},
            children: [{
                path: 'paperPreview/:paperId',
                name: 'trainPlanDetailPaper',
                component: PaperPreview,
                props: true,
            }]
        }, {
            path: 'offlineDetail/:planId',
            name: 'offlinePlanDetail',
            component: () => import('@/pages/Train/OfflinePlanDetail'),
            props: true,
            meta: {title: i18n.t('train.trainDetail')},
        }, {
            path: 'edit/:planId',
            name: 'editTrainPlan',
            component: () => import('@pages/Train/TrainPlanEdit/index'),
            props: true,
            meta: {title: i18n.t('train.editTraining')},
        }, {
            path: 'editOffline/:planId',
            name: 'editOfflinePlan',
            component: () => import('@pages/Train/OfflinePlanEdit'),
            props: true,
            meta: {title: i18n.t('train.editTraining')},
        }]
    }, {
        path: '/train/planRecord',
        name: 'planRecord',
        component: () => import('@/pages/Train/PlanRecord'),
        children: [{
            path: 'detail/:planId/:creator',
            name: 'planRecordDetail',
            component: () => import('@/pages/Train/PlanRecordDetail'),
            props: true,
            meta: {title: i18n.t('train.planDetail')},
        },
            {
                path: 'offlineDetail/:planId/:creator',
                name: 'offlineRecordDetail',
                component: () => import('@/pages/Train/OfflineRecordDetail'),
                props: true,
                meta: {title: i18n.t('train.planDetail')},
            }]
    },{
        path: '/train/student',
        name: 'trainStudent',
        component: () => import('@pages/User/User'),
        children: [{
            path: 'detail/:id',
            name: 'studentProfile',
            component: () => import('@pages/User/UserDetail'),
            props: true,
            meta: {title: '学员档案'}
        }]
    },

    // 图库管理
    {
        path: '/mapManage/mapct',
        name: 'mapct',
        component: () => import('@/pages/MapManage/MapCt')
    }, {
        path: '/mapManage/mapdr',
        name: 'mapdr',
        component: () => import('@/pages/MapManage/MapDr')
    }, {
        path: '/mapManage/mapfiscan',
        name: 'mapfiscan',
        component: () => import('@/pages/MapManage/MapFiscan')
    },
    // 漏检图库（科室）
    {
        path: '/mapManage/mapCollect',
        name: 'mapCollect',
        component: () => import('@/pages/MapCollect/Index'),
        children: [{
            path: 'addOmit',
            name: 'addOmitMap',
            component: () => import('@/pages/MapCollect/EditMap'),
            meta: {title: '添加漏检图像'},
        }, {
            path: 'editOmit/:id',
            name: 'editOmitMap',
            component: () => import('@/pages/MapCollect/EditMap'),
            props: true,
            meta: {title: '编辑漏检图像'},
        },{
            path: 'addGood',
            name: 'addGoodMap',
            component: () => import('@/pages/MapCollect/EditMap'),
            meta: {title: '添加优质图像'},
        }, {
            path: 'editGood/:id',
            name: 'editGoodMap',
            component: () => import('@/pages/MapCollect/EditMap'),
            props: true,
            meta: {title: '编辑优质图像'},
        }]
    },
    // 漏检图库（后台）
    {
        path: '/mapManage/mapCollectBackend',
        name: 'mapCollectBG',
        component: () => import('@/pages/MapCollect/Index'),
        children: [{
            path: 'addOmit',
            name: 'addOmitMapBG',
            component: () => import('@/pages/MapCollect/EditMap'),
            meta: {title: '添加漏检图像'},
        }, {
            path: 'editOmit/:id',
            name: 'editOmitMapBG',
            component: () => import('@/pages/MapCollect/EditMap'),
            props: true,
            meta: {title: '编辑漏检图像'},
        },{
            path: 'addGood',
            name: 'addGoodMapBG',
            component: () => import('@/pages/MapCollect/EditMap'),
            meta: {title: '添加优质图像'},
        }, {
            path: 'editGood/:id',
            name: 'editGoodMapBG',
            component: () => import('@/pages/MapCollect/EditMap'),
            props: true,
            meta: {title: '编辑优质图像'},
        }]
    },

    // 资源管理
    {
        path: '/resManager/resViews',
        name: 'resViews',
        component: ResViews,
        children: [{
            path: ':id',
            name: 'resDetail',
            component: ResDetail,
            meta: {title: '文件预览'},
        }]
    },{
        path: '/resManager/imageResource',
        name: 'imageResource',
        component: () => import('@/pages/ResManager/ImageResource')
    }, {
        path: '/resManager/knowledgeBase',
        name: 'KnowledgeBase',
        component: KnowledgeBase,
    },

    // 课件管理
    {
        path: '/course/course',
        name: 'course',
        component: Course,
    }, {
        path: '/course/myCourse',
        name: 'myCourse',
        component: MyCourse,
        children: [{
            path: 'theoryCourseAdd',
            name: 'theoryCourseAdd',
            component: TheoryCourseAdd,
            meta: {title: i18n.t('course.theoryCoursewareMake')},
        }, {
            path: 'editTheoryCourse/:courseId',
            name: 'editTheoryCourse',
            component: TheoryCourseAdd,
            props: true,
            meta: {title: i18n.t('course.theoryCoursewareEdit')},
        }, {
            path: 'imageCourseAdd',
            name: 'imageCourseAdd',
            component: ImageCourseAdd,
            meta: {title: i18n.t('course.imageCoursewareMake')},
        }, {
            path: 'editImageCourse/:courseId/:courseType',
            name: 'editImageCourse',
            component: ImageCourseAdd,
            props: true,
            meta: {title: i18n.t('course.imageCoursewareEdit')},
        },

        ]
    },
    {
        path: '/mapManage/test',
        name: 'testDR',
        component: () => import('@/pages/MapManage/test'),
        props: true
    },

    /**
     * 考试管理
     */
    {
        path: '/topic/library',
        name: 'topicLibrary',
        component: () => import('@/pages/Topic/TopicLibrary')
    },
    {
        path: '/topic/my',
        name: 'myTopic',
        component: () => import('@/pages/Topic/MyTopic'),
        children: [{
            path: 'add',
            name: 'myTopicAdd',
            component: () => import('@/pages/Topic/MyTopicAdd'),
            meta: {title: i18n.t('topic.addTopic')},
        }, {
            path: 'edit/:id/:type',
            name: 'myTopicEdit',
            component: () => import('@/pages/Topic/MyTopicAdd'),
            props: true,
            meta: {title: i18n.t('topic.editTopic')},
        }, {
            path: 'batch',
            name: 'myTopicAddBatch',
            component: () => import('@/pages/Topic/MyTopicAddBatch'),
            meta: {title: '可视化录入'},
        }]
    },

    // 题组
    {
        path: '/topicSet/topic',
        name: 'topicSet',
        alias: '/topic/topicSet',
        component: () => import('@/pages/TopicSet/TopicIndex'),
        children: [ {
            path: 'detail/:id',
            name: 'topicSetDetail',
            component: () => import('@/pages/TopicSet/TopicSetDetail'),
            props: true,
            meta: {title: '题组详情'},
        }]
    },
    // 每日一练
    {
        path: '/topicSet/daily',
        name: 'dailyTopicSet',
        component: () => import('@/pages/TopicSet/DailyIndex'),
        children: [ {
            path: 'detail/:id',
            name: 'dailyTopicSetDetail',
            component: () => import('@pages/TopicSet/TopicSetDetail'),
            props: true,
            meta: {title: '题组详情'},
        }]
    },

    // 考卷
    {
        path: '/paper/library',
        name: 'paperLibrary',
        component: () => import('@/pages/Paper/PaperLibrary')
    },
    {
        path: '/paper/my',
        name: 'myPaper',
        component: () => import('@/pages/Paper/MyPaper'),
        children: [{
            path: 'addTheoryPaper',
            name: 'addTheoryPaper',
            component: () => import('@/pages/Paper/AddTheoryPaper'),
            meta: {title: i18n.t('paper.theoryPaperMake')},
            children: [{
                path: 'editTopic',
                name: 'addTheoryPaperEditTopic',
                component: () => import('@pages/Paper/Topic/EditTheoryTopic'),
                meta: {title: i18n.t('topic.editTopic')},
            }, {
                path: 'editMatchTopic',
                name: 'addPaperMatchEditTopic',
                component: () => import('@pages/Paper/Topic/EditMatchTopic'),
                meta: {title: i18n.t('topic.editTopic')},
            }, {
                path: 'editTheoryGraphic',
                name: 'addPaperTheoryGraphic',
                component: () => import('@pages/Paper/Topic/EditTheoryGraphicTopic'),
                meta: {title: i18n.t('topic.editTopic')},
            }, {
                path: 'paperPreview',
                name: 'addTheoryPaperPreview',
                component: PaperPreview,
            },]
        }, {
            path: 'editTheoryPaper/:paperId',
            name: 'editTheoryPaper',
            component: () => import('@/pages/Paper/AddTheoryPaper'),
            props: true,
            meta: {title: i18n.t('paper.theoryPaperEdit')},
            children: [{
                path: 'editTopic',
                name: 'editTheoryPaperEditTopic',
                component: () => import('@/pages/Paper/Topic/EditTheoryTopic'),
                meta: {title: i18n.t('topic.editTopic')},
            },{
                path: 'editMatchTopic',
                name: 'editPaperMatchEditTopic',
                component: () => import('@/pages/Paper/Topic/EditMatchTopic'),
                meta: {title: i18n.t('topic.editTopic')},
            },{
                path: 'editTheoryGraphic',
                name: 'editPaperTheoryGraphic',
                component: () => import('@/pages/Paper/Topic/EditTheoryGraphicTopic'),
                meta: {title: i18n.t('topic.editTopic')},
            }, {
                path: 'paperPreview',
                name: 'editTheoryPaperPreview',
                component: PaperPreview,
            },]
        }, {
            path: 'addImagePaper',
            name: 'addImagePaper',
            component: () => import('@/pages/Paper/AddImagePaper'),
            meta: {title: i18n.t('paper.imagePaperMake')},
            children: [{
                path: 'editCT',
                name: 'addImagePaperEditCT',
                component: () => import('@/pages/Topic/Components/CTTopic'),
                meta: {title: i18n.t('topic.editTopic')},
                props: true,
            }, {
                path: 'editDR',
                name: 'addImagePaperEditDR',
                component: () => import('@/pages/Topic/Components/DRTopic'),
                meta: {title: i18n.t('topic.editTopic')},
                props: true,
            }]
        }, {
            path: 'editImagePaper/:paperId/:paperType',
            name: 'editImagePaper',
            component: () => import('@/pages/Paper/AddImagePaper'),
            props: true,
            meta: {title: i18n.t('paper.imagePaperEdit')},
            children: [{
                path: 'editCT',
                name: 'editImagePaperEditCT',
                component: () => import('@/pages/Topic/Components/CTTopic'),
                meta: {title: i18n.t('topic.editTopic')},
                props: true,
            }, {
                path: 'editDR',
                name: 'editImagePaperEditDR',
                component: () => import('@/pages/Topic/Components/DRTopic'),
                meta: {title: i18n.t('topic.editTopic')},
                props: true,
            }]
        },
            {
                path: 'addFiscanPaper',
                name: 'addFiscanPaper',
                component: () => import('@/pages/Paper/AddFiscanPaper'),
                meta: {title: '职鉴考卷制作'},
            },
            {
                path: 'editFiscanPaper/:paperId',
                name: 'editFiscanPaper',
                component: () => import('@/pages/Paper/AddFiscanPaper'),
                props: true,
                meta: {title: '职鉴考卷编辑'},
                children: [{
                    path: 'paperPreview',
                    name: 'editFiscanPaperPreview',
                    component: PaperPreview,
                }]
            }
        ],
    },

    {
        path: '/paper/paperPreview/:paperId',
        name: 'paperPreview',
        component: PaperPreview,
        meta: {single: true},
        props: true
    },

    {
        path: '/survey/survey',
        name: 'survey',
        component: () => import('@pages/Survey/Old/SurveyManage'),
        children: [{
            path: 'addSurveyPaper',
            name: 'addSurveyPaper',
            component: () => import('@pages/Survey/Old/AddSurveyPaper'),
            meta: {title: i18n.t('survey.add')},
        }, {
            path: 'editSurveyPaper/:id',
            name: 'editSurveyPaper',
            component: () => import('@pages/Survey/Old/AddSurveyPaper'),
            props: true,
            meta: {title: i18n.t('survey.edit')},
        }, {
            path: 'viewSurveyPaper/:id',
            name: 'viewSurveyPaper',
            component: () => import('@pages/Survey/Old/ViewSurveyPaper'),
            props: true
        }]
    },
    //调查问卷new
    {
        path: '/survey/surveyNew',
        name: 'surveyNew',
        component: () => import('@pages/Survey/SurveyIndex'),
        children: [{
            path: 'addSurveyNew',
            name: 'addSurveyNew',
            component: () => import('@pages/Survey/SurveyEdit'),
            meta: {title: i18n.t('survey.add')},
        }, {
            path: 'editSurveyNew/:id',
            name: 'editSurveyNew',
            component: () => import('@pages/Survey/SurveyEdit'),
            props: true,
            meta: {title: i18n.t('survey.edit')},
        }, {
            path: 'viewSurveyNew/:id',
            name: 'viewSurveyNew',
            component: () => import('@pages/Survey/SurveyView'),
            props: true
        }]
    },
    // 证书管理
    {
        path: '/certificate/query',
        name: 'certificate',
        component: () => import('@/pages/Certificate/CertificateQuery'),
        children: [{
            path: 'addCertificate',
            name: 'addCertificate',
            component: () => import('@/pages/Certificate/AddCertificate'),
            meta: {title: i18n.t('system.certAdd')}
        }, {
            path: 'editCertificate/:userID',
            name: 'editCertificate',
            component: () => import('@/pages/Certificate/AddCertificate'),
            props: true,
            meta: {title: i18n.t('system.certDetail')}
        }]
    },
    //开岗放权
    {
        path: '/certificate/preJobApproval',
        name: 'preJobApproval',
        component: () => import('@/pages/Certificate/PreJobApproval'),
        meta: {title: i18n.t('system.preJobApproval')},
    },
    //群组管理
    {
        path: '/group',
        name: 'group',
        component: () => import('@/pages/Train/Group'),
    },

    // 台账管理
    {
        path: '/ledger',
        name: 'ledgerIndex',
        component: () => import('@/pages/Ledger/Index'),
        children: [{
            path: 'add',
            name: 'addLedger',
            component: () => import('@/pages/Ledger/Edit'),
            meta: {title: '添加台账'}
        }, {
            path: 'edit/:ledgerId',
            name: 'editLedger',
            component: () => import('@/pages/Ledger/Edit'),
            props: true,
            meta: {title: '编辑台账'}
        },{
            path: 'detail/:ledgerId',
            name: 'ledgerDetail',
            component: () => import('@/pages/Ledger/Detail'),
            props: true,
            meta: {title: '台账详情'},
        },{
            path: 'studentDetail/:userId',
            name: 'studentDetail',
            component: () => import('@/pages/Ledger/StudentDetail'),
            // props: true,
            meta: {title: '学员培训详情'},
            children: [{
                path: 'ledgerDetail/:ledgerId',
                name: 'studentLedgerDetail',
                component: () => import('@/pages/Ledger/Detail'),
                meta: {title: '台账详情'},
                props: true,
            }]
        }]
    },

    {
        path: '/invigilate',
        name: 'invigilateIndex',
        component: () => import('@/pages/Invigilate/Index'),
        children: [{
            path: 'detail/:id',
            name: 'invigilateDetail',
            component: () => import('@/pages/Invigilate/Detail'),
            props: true,
            meta: {title: '监考详情'},
        }]
    },

    // 培训资产管理
    {
        path: '/asset/approve',
        name: 'assetIndex',
        component: () => import('@/pages/Asset/Manage'),
        children: [{
            path: 'detail/:assetId',
            name: 'assetDetail',
            component: () => import('@/pages/Asset/Detail'),
            props: true,
            meta: {title: '审批详情'},
        }]
    },
    {
        path: '/asset/room',
        name: 'assetRoom',
        component: () => import('@/pages/Asset/Room')
    },
    // 考勤管理
    {
        path: '/attendance/timeStatistics',
        name: 'timeStatistics',
        component: () => import('@/pages/Attendance/TimeStatistics'),
        children: [{
            path: 'detail',
            name: 'attendanceTimeDetail',
            component: () => import('@/pages/Attendance/TimeDetail'),
            meta: {title: '统计详情'},
        }]
    },
    {
        path: '/attendance/scheduleSetting',
        name: 'scheduleSetting',
        component: () => import('@/pages/Attendance/ScheduleSetting'),
        children: [{
            path: 'add',
            name: 'addAttendance',
            component: () => import('@/pages/Attendance/Edit'),
            meta: {title: '添加排班'}
        }, {
            path: 'edit/:attendanceId/:type',
            name: 'editAttendance',
            component: () => import('@/pages/Attendance/Edit'),
            props: true,
            meta: {title: '编辑排班'}
        },{
            path: 'detail/:attendanceId',
            name: 'attendanceDetail',
            component: () => import('@/pages/Attendance/Detail'),
            props: true,
            meta: {title: '排班详情'},
        },{
            path: 'auditDetail/:attendanceId',
            name: 'auditDetail',
            component: () => import('@/pages/Attendance/AuditDetail'),
            props: true,
            meta: {title: '排班审核'},
        }]
    },
    // 直播设置
    {
        path: '/live/setting',
        name: 'liveSetting',
        component: () => import('@/pages/Live/LiveSetting'),
    },

    // 新直播
    {
        path: '/live/host',
        name: 'liveHost',
        component: () => import('@pages/Live2/LiveHost'),
        children: [{
            path: 'add',
            name: 'liveHostAdd',
            component: () => import('@/pages/Live2/LiveHostDetail'),
            meta: {title: '创建直播'},
        }, {
            path: ':id/:action',
            name: 'liveHostDetail',
            component: () => import('@/pages/Live2/LiveHostDetail'),
            meta: {title: '直播详情'},
            props: true,
        }]
    },
    {
        path: '/live/publish/:id',
        name: 'LivePublish',
        component: () => import('@pages/Live2/LiveHostPublish'),
        props: true,
        meta: {single: true},
    },
]
